import React from 'react';
import { addList, toggleDropBox } from '../actions'
import { connect } from 'react-redux'
import Header from '../components/Header'
import Button from '../components/Button'
import { TOGGLE_SETTING_SUCCESS, TOGGLE_SHARE_SUCCESS, TOGGLE_LISTS_SUCCESS } from '../actionTypes'

import mainImg from '../img/main-page-img.png'
import mainFooterImg1 from '../img/main-footer-img-1.png'
import mainFooterImg2 from '../img/main-footer-img-2.png'
import mainFooterImg3 from '../img/main-footer-img-3.png'
import mainFooterImg4 from '../img/main-footer-img-4.png'




const MainPage = ({ addList, toggleDropBox }) => {
    const handleAddList = () => {
        addList()
        toggleDropBox(TOGGLE_SETTING_SUCCESS)
    }

    return  (
     <div className="">
         <Header type='mainPage'/>
         <div className="main-page">
             <div className="main-page__wrap">
                 <div className="main-page__main-img-wrap" >
                     <img src={mainImg} alt="" className='main-page__main-img'/>
                 </div>

                 <div className="main-page__content">
                     <div className="main-page__left-box">
                         <h2 className='head2'>Working together is easy!</h2>
                         <div className="text1">
                             Zametix is a quick task for professionals
                             working on common projects.
                         </div>
                     </div>

                     <div className="main-page__right-box">
                         <div className="main-page__btn-wrap">
                             <Button fn={handleAddList} type='big' title='Create new project' icon='icon-plus' bg='btn_blue'/>

                         </div>
                     </div>

                 </div>
             </div>


             <div className="main-page__footer">
                 <div className="main-page__footer-wrap">
                     <h3 className='head3 t_center'>Clean and intuitive interface</h3>
                     <div className="main-plus">
                         <div className="main-plus__element">
                             <div className="main-plus__img-wrap">
                                 <img className='main-plus__img'  src={mainFooterImg1} alt=""/>
                             </div>

                             <div className="main-plus__title">Without registering</div>
                         </div>

                         <div className="main-plus__element">
                             <div className="main-plus__img-wrap">
                                 <img className='main-plus__img'  src={mainFooterImg2} alt=""/>
                             </div>

                             <div className="main-plus__title">Custom tags for tasks</div>
                         </div>

                         <div className="main-plus__element">
                             <div className="main-plus__img-wrap">
                                 <img className='main-plus__img'  src={mainFooterImg3} alt=""/>
                             </div>

                             <div className="main-plus__title">Ability to comment on tasks</div>
                         </div>

                         <div className="main-plus__element">
                             <div className="main-plus__img-wrap">
                                 <img className='main-plus__img'  src={mainFooterImg4} alt=""/>
                             </div>

                             <div className="main-plus__title">Dynamic Update<br/>all team members</div>
                         </div>
                     </div>
                 </div>
             </div>

         </div>




     </div>
 )
}

const mapDispatchToProps = {
    addList,
    toggleDropBox
}

export default connect(null, mapDispatchToProps)(MainPage);


// WEBPACK FOOTER //
// ./src/pages/MainPage.js